import metaMask from "../assets/images/meta-mask.png";
import walletConnect from "../assets/images/wallet-connect.png";
import trust from "../assets/images/trust.png";
import logo from "../assets/images/logo.svg";
import logoDfy from "../assets/images/logo-dfy.png";
import statistic_dfy from "../assets/images/statistic_dfy.png";
import laliga from "../assets/images/laliga.png";
import wales from "../assets/images/wales.png";
import finland from "../assets/images/finland.png";
import mu from "../assets/images/mu.png";
import newcas from "../assets/images/newcas.png";
import chelsea from "../assets/images/chelsea.png";
import mancity from "../assets/images/mancity.png";
import aficanationscup from "../assets/images/league/aficacupnations.png";
import burkinafaso from "../assets/images/country/afica/burkina-faso.png";
import cameroon from "../assets/images/country/afica/cameroon.png";
import capeVerde from "../assets/images/country/afica/cape-verde.png";
import ethiopia from "../assets/images/country/afica/ethiopia.png";
import guinea from "../assets/images/country/afica/guinea.png";
import malawi from "../assets/images/country/afica/malawi.png";
import senegal from "../assets/images/country/afica/senegal.png";
import zimbabwe from "../assets/images/country/afica/zimbabwe.png";
import gabon from "../assets/images/country/afica/gabon.png";
import Morocco from "../assets/images/country/afica/morocco.png";
import Comoros from "../assets/images/country/afica/comoros.png";
import Ghana from "../assets/images/country/afica/ghana.png";
import Nigeria from "../assets/images/country/afica/nigeria.png";
import GuineaBissau from "../assets/images/country/afica/guinea-bissau.png";
import Sudan from "../assets/images/country/afica/sudan.png";
import Egypt from "../assets/images/country/afica/egypt.png";
import IvoryCoast from "../assets/images/country/afica/ivory-coast.png";
import Algeria from "../assets/images/country/afica/algeria.png";
import SierraLeone from "../assets/images/country/afica/sierra-leone.png";
import EquatorialGuinea from "../assets/images/country/afica/equatorial-guinea.png";
import Gambia from "../assets/images/country/afica/gambia.png";
import Mali from "../assets/images/country/afica/mali.png";
import Mauritania from "../assets/images/country/afica/mauritania.png";
import Tunisia from "../assets/images/country/afica/tunisia.png";
import France from "../assets/images/country/france.png";
import BannerBarca from "../assets/images/event/Banner_Barca.png";
import Banner_Barca2 from "../assets/images/event/Banner_Barca2.png";
import Banner_Ronaldo from "../assets/images/event/Banner_Ronaldo.png";
import Banner_Ronaldo2 from "../assets/images/event/Banner_Ronaldo2.png";
import header_box from "../assets/images/header_box.jpg";
import logo_barca from "../assets/images/event/barcelona_logo.png";
import man_united_logo from "../assets/images/event/man_united.png";
import PremierLeague from "../assets/images/event/PremierLeague.png";
import Africa_Cup_logo from "../assets/images/event/Africa_Cup.png";
import minigame_background from "../assets/images/minigame_background.png";
import closed from "../assets/images/action/closed.png";
import checked from "../assets/images/action/check.png";
import Banner_EPL2 from "../assets/images/event/Banner_EPL2.png";
import NotFound from "../assets/images/action/404error.png";

const Images = {
  NotFound,
  Banner_EPL2,
  checked,
  closed,
  minigame_background,
  Africa_Cup_logo,
  PremierLeague,
  man_united_logo,
  logo_barca,
  header_box,
  Banner_Ronaldo2,
  Banner_Ronaldo,
  Banner_Barca2,
  BannerBarca,
  Tunisia,
  Mauritania,
  Mali,
  Gambia,
  EquatorialGuinea,
  SierraLeone,
  Algeria,
  IvoryCoast,
  Egypt,
  Sudan,
  GuineaBissau,
  Nigeria,
  metaMask,
  walletConnect,
  trust,
  logo,
  logoDfy,
  statistic_dfy,
  laliga,
  wales,
  finland,
  mu,
  newcas,
  chelsea,
  mancity,
  aficanationscup,
  burkinafaso,
  cameroon,
  capeVerde,
  ethiopia,
  guinea,
  malawi,
  senegal,
  zimbabwe,
  gabon,
  Morocco,
  Comoros,
  Ghana,
  France,
};

export default Images;
